export interface ResponseError {
  response: {
    data: {
      error_code: string
      error_message: string
    }
    status_code: number
    status?: number
  }
}

const hasAttribute = <T extends string>(
  obj: unknown,
  attr: T,
): obj is Record<T, unknown> => {
  if (!obj) {
    return false
  }

  if (typeof obj !== 'object') {
    return false
  }

  if (!(attr in obj)) {
    return false
  }
  return true
}

export const isResponseErrorWithErrorCode = (
  err: unknown,
): err is ResponseError => {
  if (!hasAttribute(err, 'response')) {
    return false
  }

  if (!hasAttribute(err.response, 'data')) {
    return false
  }

  if (!hasAttribute(err.response.data, 'error_code')) {
    return false
  }

  return true
}

export const getResponseErrorCode = (err: unknown) => {
  if (isResponseErrorWithErrorCode(err)) {
    return err.response.data.error_code
  }

  return undefined
}

export const hasResponseErrorStatus = (err: unknown, status: number) => {
  if (!hasAttribute(err, 'response')) {
    return false
  }

  if (hasAttribute(err.response, 'status') && err.response.status === status) {
    return true
  }

  if (
    hasAttribute(err.response, 'status_code') &&
    err.response.status_code === status
  ) {
    return true
  }

  return false
}
